module.exports = __webpack_public_path__ + "static/media/border-bottom.a1018106.svg";